<div class="fw-semibold" *ngIf="userDetails?.emailVerified">
    {{ userDetails?.email ? (inlineVerificationDate ? 'Verified' : userDetails?.email) : '' }}
    <fa-icon [icon]="faCircleCheck" class="check-mark ms-1"></fa-icon>
    <div [ngClass]="{'text-nowrap d-inline': inlineVerificationDate}" class="fw-normal">
        {{ userDetails?.emailVerified | formatDateArray : true }}
    </div>
</div>
<div *ngIf="!userDetails?.emailVerified" class="fw-normal">
    <div class="fw-semibold">Pending</div>
    <div *ngIf="!inlineVerificationDate"> {{'\u2014'}} </div>
</div>
